import classNames from 'classnames'
import { ReactNode } from 'react'
import { SignupButton } from '../signup-button/SignupButton.component'
import styles from './HowNcWorks.module.scss'

export interface HowNcWorksProps {
  heading: string
  image?: {
    alt: string
    url: string
  }
  media?: {
    title: string
    url: string
  }
  content: string
  secondImage?: {
    alt: string
    url: string
  }
  secondMedia?: {
    title: string
    url: string
  }
  secondContent: string
  regularPaddingTop?: boolean
  showCta?: boolean
  cta?: string
  page?: 'homepage'
}

export function HowNcWorks({
  heading,
  image,
  media,
  secondImage,
  secondMedia,
  content,
  secondContent,
  regularPaddingTop = false,
  showCta = false,
  cta,
  page,
}: HowNcWorksProps): ReactNode {
  const sectionClass = classNames(styles.HowNcWorks, {
    [styles.HowNcWorks___regularPaddingTop]: regularPaddingTop,
    [styles.HowNcWorks___homepage]: page === 'homepage',
  })

  return (
    <section className={sectionClass}>
      <h2 className={styles.HowNcWorks__heading}>{heading}</h2>

      {media ? (
        <video
          className={styles.HowNcWorks__media}
          title={media.title}
          autoPlay
          playsInline
          muted
          loop
        >
          <source src={media.url} type="video/mp4" />
        </video>
      ) : (
        <img className={styles.HowNcWorks__img} src={image?.url} alt={image?.alt} />
      )}
      <p className={styles.HowNcWorks__content}>{content}</p>
      {secondMedia ? (
        <video
          className={styles.HowNcWorks__media}
          title={secondMedia.title}
          autoPlay
          playsInline
          muted
          loop
        >
          <source src={secondMedia.url} type="video/mp4" />
        </video>
      ) : (
        <img className={styles.HowNcWorks__img} src={secondImage?.url} alt={secondImage?.alt} />
      )}

      <p className={styles.HowNcWorks__content}>{secondContent}</p>

      {showCta && (
        <div className={styles.HowNcWorks__cta}>
          <SignupButton theme="brandPurple">{cta}</SignupButton>
        </div>
      )}
    </section>
  )
}
